module.exports = __webpack_public_path__ + "fonts/Rokkitt-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Rokkitt/Rokkitt-Regular.woff2
// module id = 3479
// module chunks = 0